var map = {
	"./a_analitico": 65,
	"./a_analitico.png": 65,
	"./a_estrategico": 66,
	"./a_estrategico.png": 66,
	"./anagrama": 67,
	"./anagrama-tirant": 68,
	"./anagrama-tirant.svg": 68,
	"./anagrama.svg": 67,
	"./anagrama_tirant_blanco": 58,
	"./anagrama_tirant_blanco.png": 58,
	"./analytics/analytics_peq": 69,
	"./analytics/analytics_peq.png": 69,
	"./analytics/bghead": 70,
	"./analytics/bghead.png": 70,
	"./arg/bghead": 71,
	"./arg/bghead.png": 71,
	"./bg-circle": 72,
	"./bg-circle-front": 73,
	"./bg-circle-front.png": 73,
	"./bg-circle.png": 72,
	"./bin-card/icoAi": 59,
	"./bin-card/icoAi.png": 59,
	"./bol/bghead": 74,
	"./bol/bghead.png": 74,
	"./bra/bghead": 75,
	"./bra/bghead.png": 75,
	"./calculos_laborales_bg": 76,
	"./calculos_laborales_bg.png": 76,
	"./calculos_laborales_ico": 77,
	"./calculos_laborales_ico.png": 77,
	"./cgae/bannerheader": 78,
	"./cgae/bannerheader.png": 78,
	"./cgae/bghead": 79,
	"./cgae/bghead.png": 79,
	"./cgae/rlogo": 80,
	"./cgae/rlogo.png": 80,
	"./chl/bghead": 81,
	"./chl/bghead.png": 81,
	"./chl/favicon.ico": 508,
	"./col/bghead": 82,
	"./col/bghead.png": 82,
	"./col/favicon.ico": 509,
	"./common/anfix": 83,
	"./common/anfix.svg": 83,
	"./common/bell": 84,
	"./common/bell.svg": 84,
	"./common/calendar_leads": 85,
	"./common/calendar_leads.png": 85,
	"./common/news": 86,
	"./common/news-solid": 87,
	"./common/news-solid.svg": 87,
	"./common/news.svg": 86,
	"./common/newspaper": 88,
	"./common/newspaper.svg": 88,
	"./common/notes": 89,
	"./common/notes.svg": 89,
	"./common/save": 90,
	"./common/save.svg": 90,
	"./common/sofia": 60,
	"./common/sofia.svg": 60,
	"./common/user": 91,
	"./common/user.svg": 91,
	"./conmex/analytics": 92,
	"./conmex/analytics.png": 92,
	"./conmex/bghead": 93,
	"./conmex/bghead.png": 93,
	"./conmex/biblioteca": 94,
	"./conmex/biblioteca.png": 94,
	"./conmex/calculator": 95,
	"./conmex/calculator.png": 95,
	"./conmex/consultoria": 96,
	"./conmex/consultoria.png": 96,
	"./conmex/gacetas": 97,
	"./conmex/gacetas.png": 97,
	"./conmex/gestion": 98,
	"./conmex/gestion.png": 98,
	"./conmex/herramientas": 99,
	"./conmex/herramientas.png": 99,
	"./conmex/legislacion": 100,
	"./conmex/legislacion.png": 100,
	"./conmex/novedades": 101,
	"./conmex/novedades.png": 101,
	"./conmex/peticiones": 102,
	"./conmex/peticiones.png": 102,
	"./conmex/rfcs": 103,
	"./conmex/rfcs.png": 103,
	"./conmex/temas": 104,
	"./conmex/temas.png": 104,
	"./conversa/ico_conversa_close": 20,
	"./conversa/ico_conversa_close.png": 20,
	"./conversa/ico_conversa_float": 21,
	"./conversa/ico_conversa_float.png": 21,
	"./conversa/logoConversa": 22,
	"./conversa/logoConversa.png": 22,
	"./conversa/logoConversaIco": 23,
	"./conversa/logoConversaIco.png": 23,
	"./conversa/logo_Conversa_Color": 24,
	"./conversa/logo_Conversa_Color.png": 24,
	"./conversa/logo_Conversa_Color_Part": 25,
	"./conversa/logo_Conversa_Color_Part.png": 25,
	"./cri/bghead": 105,
	"./cri/bghead.png": 105,
	"./cri/favicon.ico": 510,
	"./dom/bghead": 106,
	"./dom/bghead.png": 106,
	"./domenj/JuritecaBeta": 107,
	"./domenj/JuritecaBeta.jpg": 107,
	"./domenj/aecid": 108,
	"./domenj/aecid.png": 108,
	"./domenj/bghead": 109,
	"./domenj/bghead.png": 109,
	"./domenj/favicon.ico": 511,
	"./domenj/home": 110,
	"./domenj/home.png": 110,
	"./domenj/home_beta": 111,
	"./domenj/home_beta.png": 111,
	"./domenj/icoFacebook": 112,
	"./domenj/icoFacebook.svg": 112,
	"./domenj/icoInstagram": 113,
	"./domenj/icoInstagram.svg": 113,
	"./domenj/icoLinked": 114,
	"./domenj/icoLinked.svg": 114,
	"./domenj/icoX": 115,
	"./domenj/icoX.svg": 115,
	"./domenj/icoYoutube": 116,
	"./domenj/icoYoutube.svg": 116,
	"./domenj/img-nosotros-contacto": 117,
	"./domenj/img-nosotros-contacto.png": 117,
	"./domenj/img-nosotros-header": 118,
	"./domenj/img-nosotros-header.png": 118,
	"./domenj/img__Form__Suggets": 119,
	"./domenj/img__Form__Suggets.png": 119,
	"./domenj/logosPJRD-ENJ": 120,
	"./domenj/logosPJRD-ENJ.png": 120,
	"./domenj/pasos_juriteca": 121,
	"./domenj/pasos_juriteca.png": 121,
	"./ecu/bghead": 122,
	"./ecu/bghead.png": 122,
	"./flags/ca": 123,
	"./flags/ca.gif": 123,
	"./flags/en": 124,
	"./flags/en.gif": 124,
	"./flags/es": 125,
	"./flags/es.gif": 125,
	"./flags/eu": 126,
	"./flags/eu.gif": 126,
	"./flags/fr": 127,
	"./flags/fr.gif": 127,
	"./flags/gl": 128,
	"./flags/gl.gif": 128,
	"./flags/va": 129,
	"./flags/va.gif": 129,
	"./gestor_notarial_bg": 130,
	"./gestor_notarial_bg.png": 130,
	"./gestor_notarial_ico": 131,
	"./gestor_notarial_ico.png": 131,
	"./gtm/bghead": 132,
	"./gtm/bghead.png": 132,
	"./head-anagrama": 133,
	"./head-anagrama.svg": 133,
	"./hnd/bghead": 134,
	"./hnd/bghead.png": 134,
	"./img_Asistente_Documental": 135,
	"./img_Asistente_Documental.jpg": 135,
	"./img_Solicitud_Formularios": 136,
	"./img_Solicitud_Formularios.jpg": 136,
	"./jam/bghead": 137,
	"./jam/bghead.png": 137,
	"./latam/bghead": 138,
	"./latam/bghead.png": 138,
	"./legal-text": 139,
	"./legal-text.svg": 139,
	"./logo_tirant_wh": 140,
	"./logo_tirant_wh.svg": 140,
	"./materias/IcoArrendamientosUrbanos": 141,
	"./materias/IcoArrendamientosUrbanos.svg": 141,
	"./materias/IcoConcursal": 142,
	"./materias/IcoConcursal.svg": 142,
	"./materias/IcoContabilidad": 143,
	"./materias/IcoContabilidad.svg": 143,
	"./materias/IcoContratos": 144,
	"./materias/IcoContratos.svg": 144,
	"./materias/IcoDefault": 145,
	"./materias/IcoDefault.svg": 145,
	"./materias/IcoEjecucionPenal": 146,
	"./materias/IcoEjecucionPenal.svg": 146,
	"./materias/IcoExtranjeria": 147,
	"./materias/IcoExtranjeria.svg": 147,
	"./materias/IcoFamilia": 148,
	"./materias/IcoFamilia.svg": 148,
	"./materias/IcoFinanciero": 149,
	"./materias/IcoFinanciero.svg": 149,
	"./materias/IcoLaboral": 150,
	"./materias/IcoLaboral.svg": 150,
	"./materias/IcoMercantil": 151,
	"./materias/IcoMercantil.svg": 151,
	"./materias/IcoPenal": 152,
	"./materias/IcoPenal.svg": 152,
	"./materias/IcoPropiedadH": 153,
	"./materias/IcoPropiedadH.svg": 153,
	"./materias/IcoUrbanismo": 154,
	"./materias/IcoUrbanismo.svg": 154,
	"./nic/bghead": 155,
	"./nic/bghead.png": 155,
	"./pan/bghead": 156,
	"./pan/bghead.png": 156,
	"./per/bghead": 157,
	"./per/bghead.png": 157,
	"./prt/bghead": 158,
	"./prt/bghead.png": 158,
	"./pry/bghead": 159,
	"./pry/bghead.png": 159,
	"./slv/bghead": 160,
	"./slv/bghead.png": 160,
	"./slv/favicon.ico": 512,
	"./sofia/sofia-color": 42,
	"./sofia/sofia-color.png": 42,
	"./sofia/sofia-color_xl": 53,
	"./sofia/sofia-color_xl.png": 53,
	"./sofia/sofia-footer": 54,
	"./sofia/sofia-footer.png": 54,
	"./sofia/sofia-info-3d": 55,
	"./sofia/sofia-info-3d.png": 55,
	"./sofia/sofia-selection": 50,
	"./sofia/sofia-selection.png": 50,
	"./sort_asc": 161,
	"./sort_asc.png": 161,
	"./sort_asc_disabled": 162,
	"./sort_asc_disabled.png": 162,
	"./sort_both": 163,
	"./sort_both.png": 163,
	"./sort_desc": 164,
	"./sort_desc.png": 164,
	"./sort_desc_disabled": 165,
	"./sort_desc_disabled.png": 165,
	"./spinner": 166,
	"./spinner.gif": 166,
	"./spinner_colors": 167,
	"./spinner_colors.svg": 167,
	"./tase/bghead": 168,
	"./tase/bghead-old": 169,
	"./tase/bghead-old.png": 169,
	"./tase/bghead.png": 168,
	"./tase/external/icos/ico-actualidad": 170,
	"./tase/external/icos/ico-actualidad.svg": 170,
	"./tase/external/icos/ico-analytics": 171,
	"./tase/external/icos/ico-analytics.svg": 171,
	"./tase/external/icos/ico-asistente": 172,
	"./tase/external/icos/ico-asistente.svg": 172,
	"./tase/external/icos/ico-ayudas": 173,
	"./tase/external/icos/ico-ayudas.svg": 173,
	"./tase/external/icos/ico-back-actualidad": 174,
	"./tase/external/icos/ico-back-actualidad.svg": 174,
	"./tase/external/icos/ico-back-analytics": 175,
	"./tase/external/icos/ico-back-analytics.svg": 175,
	"./tase/external/icos/ico-back-asistente": 176,
	"./tase/external/icos/ico-back-asistente.svg": 176,
	"./tase/external/icos/ico-back-ayudas": 177,
	"./tase/external/icos/ico-back-ayudas.svg": 177,
	"./tase/external/icos/ico-back-base-de-datos": 178,
	"./tase/external/icos/ico-back-base-de-datos.svg": 178,
	"./tase/external/icos/ico-back-biblioteca-gps": 179,
	"./tase/external/icos/ico-back-biblioteca-gps.svg": 179,
	"./tase/external/icos/ico-back-biblioteca-t-conecta": 180,
	"./tase/external/icos/ico-back-biblioteca-t-conecta.svg": 180,
	"./tase/external/icos/ico-back-biblioteca-virtual": 181,
	"./tase/external/icos/ico-back-biblioteca-virtual.svg": 181,
	"./tase/external/icos/ico-back-calculadoras": 182,
	"./tase/external/icos/ico-back-calculadoras.svg": 182,
	"./tase/external/icos/ico-back-computo": 183,
	"./tase/external/icos/ico-back-computo.svg": 183,
	"./tase/external/icos/ico-back-consultoria": 184,
	"./tase/external/icos/ico-back-consultoria.svg": 184,
	"./tase/external/icos/ico-back-convenios": 185,
	"./tase/external/icos/ico-back-convenios.svg": 185,
	"./tase/external/icos/ico-back-db-latam": 186,
	"./tase/external/icos/ico-back-db-latam.svg": 186,
	"./tase/external/icos/ico-back-diario": 187,
	"./tase/external/icos/ico-back-diario.svg": 187,
	"./tase/external/icos/ico-back-dictado": 188,
	"./tase/external/icos/ico-back-dictado.svg": 188,
	"./tase/external/icos/ico-back-gestor-despachos": 189,
	"./tase/external/icos/ico-back-gestor-despachos.svg": 189,
	"./tase/external/icos/ico-back-legislacion": 190,
	"./tase/external/icos/ico-back-legislacion.svg": 190,
	"./tase/external/icos/ico-back-solicitud": 191,
	"./tase/external/icos/ico-back-solicitud.svg": 191,
	"./tase/external/icos/ico-back-traducciones": 192,
	"./tase/external/icos/ico-back-traducciones.svg": 192,
	"./tase/external/icos/ico-base-de-datos": 193,
	"./tase/external/icos/ico-base-de-datos.svg": 193,
	"./tase/external/icos/ico-biblioteca-gps": 194,
	"./tase/external/icos/ico-biblioteca-gps.svg": 194,
	"./tase/external/icos/ico-biblioteca-t-conecta": 195,
	"./tase/external/icos/ico-biblioteca-t-conecta.svg": 195,
	"./tase/external/icos/ico-biblioteca-virtual": 196,
	"./tase/external/icos/ico-biblioteca-virtual.svg": 196,
	"./tase/external/icos/ico-btn-up": 197,
	"./tase/external/icos/ico-btn-up.svg": 197,
	"./tase/external/icos/ico-calculadoras": 198,
	"./tase/external/icos/ico-calculadoras.svg": 198,
	"./tase/external/icos/ico-computo": 199,
	"./tase/external/icos/ico-computo.svg": 199,
	"./tase/external/icos/ico-consultoria": 200,
	"./tase/external/icos/ico-consultoria.svg": 200,
	"./tase/external/icos/ico-convenios": 201,
	"./tase/external/icos/ico-convenios.svg": 201,
	"./tase/external/icos/ico-db-latam": 202,
	"./tase/external/icos/ico-db-latam.svg": 202,
	"./tase/external/icos/ico-diario": 203,
	"./tase/external/icos/ico-diario.svg": 203,
	"./tase/external/icos/ico-dictado": 204,
	"./tase/external/icos/ico-dictado.svg": 204,
	"./tase/external/icos/ico-footer-facebook": 205,
	"./tase/external/icos/ico-footer-facebook.svg": 205,
	"./tase/external/icos/ico-footer-instragram": 206,
	"./tase/external/icos/ico-footer-instragram.svg": 206,
	"./tase/external/icos/ico-footer-linkedin": 207,
	"./tase/external/icos/ico-footer-linkedin.svg": 207,
	"./tase/external/icos/ico-footer-twitter": 208,
	"./tase/external/icos/ico-footer-twitter.svg": 208,
	"./tase/external/icos/ico-footer-youtube": 209,
	"./tase/external/icos/ico-footer-youtube.svg": 209,
	"./tase/external/icos/ico-gestor-despachos": 210,
	"./tase/external/icos/ico-gestor-despachos.svg": 210,
	"./tase/external/icos/ico-legislacion": 211,
	"./tase/external/icos/ico-legislacion.svg": 211,
	"./tase/external/icos/ico-llamada": 212,
	"./tase/external/icos/ico-llamada.svg": 212,
	"./tase/external/icos/ico-solicitud": 213,
	"./tase/external/icos/ico-solicitud.svg": 213,
	"./tase/external/icos/ico-traducciones": 214,
	"./tase/external/icos/ico-traducciones.svg": 214,
	"./tase/external/icos/ico-whatsapp": 215,
	"./tase/external/icos/ico-whatsapp.svg": 215,
	"./tase/external/img/bbGPS": 216,
	"./tase/external/img/bbGPS.svg": 216,
	"./tase/external/img/bg-aro-content": 217,
	"./tase/external/img/bg-aro-content.svg": 217,
	"./tase/external/img/btn-call": 218,
	"./tase/external/img/btn-call.svg": 218,
	"./tase/external/img/btn-plus": 219,
	"./tase/external/img/btn-plus-hover": 220,
	"./tase/external/img/btn-plus-hover.svg": 220,
	"./tase/external/img/btn-plus.svg": 219,
	"./tase/external/img/btn-whatsapp": 221,
	"./tase/external/img/btn-whatsapp.svg": 221,
	"./tase/external/img/header-compu-hero": 222,
	"./tase/external/img/header-compu-hero.svg": 222,
	"./tase/external/logos/logo-bbGP": 223,
	"./tase/external/logos/logo-bbGP.svg": 223,
	"./tase/external/logos/logo-conversa": 224,
	"./tase/external/logos/logo-conversa.svg": 224,
	"./tase/external/logos/logo-footer": 225,
	"./tase/external/logos/logo-footer.svg": 225,
	"./tase/external/logos/logo-header": 226,
	"./tase/external/logos/logo-header.svg": 226,
	"./tase/external/logos/logo-sofia": 227,
	"./tase/external/logos/logo-sofia.svg": 227,
	"./tase/favicon.ico": 513,
	"./tase/icoImportant.webp": 514,
	"./tase/ico_biblioteca": 228,
	"./tase/ico_biblioteca.svg": 228,
	"./tase/ico_consultoria": 229,
	"./tase/ico_consultoria.svg": 229,
	"./timbres_honorarios_bg": 230,
	"./timbres_honorarios_bg.png": 230,
	"./timbres_honorarios_ico": 231,
	"./timbres_honorarios_ico.png": 231,
	"./tnr/bghead": 232,
	"./tnr/bghead-old": 233,
	"./tnr/bghead-old.png": 233,
	"./tnr/bghead.png": 232,
	"./tnr/ico_biblioteca": 234,
	"./tnr/ico_biblioteca.svg": 234,
	"./tnr/ico_consultoria": 235,
	"./tnr/ico_consultoria.svg": 235,
	"./tol/asistenciaporvoz": 236,
	"./tol/asistenciaporvoz.png": 236,
	"./tol/bghead": 237,
	"./tol/bghead-old": 238,
	"./tol/bghead-old.png": 238,
	"./tol/bghead.png": 237,
	"./tol/favicon.ico": 515,
	"./tol/ico_biblioteca": 239,
	"./tol/ico_biblioteca.svg": 239,
	"./tol/ico_consultoria": 240,
	"./tol/ico_consultoria.svg": 240,
	"./tolmex/bghead": 241,
	"./tolmex/bghead.png": 241,
	"./tolmex/favicon.ico": 516,
	"./tph/bghead": 242,
	"./tph/bghead-old": 243,
	"./tph/bghead-old.png": 243,
	"./tph/bghead.png": 242,
	"./tph/external/icos/btn-plus": 244,
	"./tph/external/icos/btn-plus.svg": 244,
	"./tph/external/icos/ico-actualidad": 245,
	"./tph/external/icos/ico-actualidad.svg": 245,
	"./tph/external/icos/ico-analytics": 246,
	"./tph/external/icos/ico-analytics.svg": 246,
	"./tph/external/icos/ico-asistente": 247,
	"./tph/external/icos/ico-asistente.svg": 247,
	"./tph/external/icos/ico-ayudas": 248,
	"./tph/external/icos/ico-ayudas.svg": 248,
	"./tph/external/icos/ico-back-actualidad": 249,
	"./tph/external/icos/ico-back-actualidad.svg": 249,
	"./tph/external/icos/ico-back-analytics": 250,
	"./tph/external/icos/ico-back-analytics.svg": 250,
	"./tph/external/icos/ico-back-asistente": 251,
	"./tph/external/icos/ico-back-asistente.svg": 251,
	"./tph/external/icos/ico-back-ayudas": 252,
	"./tph/external/icos/ico-back-ayudas.svg": 252,
	"./tph/external/icos/ico-back-base-de-datos": 253,
	"./tph/external/icos/ico-back-base-de-datos.svg": 253,
	"./tph/external/icos/ico-back-biblioteca-gps": 254,
	"./tph/external/icos/ico-back-biblioteca-gps.svg": 254,
	"./tph/external/icos/ico-back-biblioteca-t-conecta": 255,
	"./tph/external/icos/ico-back-biblioteca-t-conecta.svg": 255,
	"./tph/external/icos/ico-back-biblioteca-virtual": 256,
	"./tph/external/icos/ico-back-biblioteca-virtual.svg": 256,
	"./tph/external/icos/ico-back-calculadoras": 257,
	"./tph/external/icos/ico-back-calculadoras.svg": 257,
	"./tph/external/icos/ico-back-computo": 258,
	"./tph/external/icos/ico-back-computo.svg": 258,
	"./tph/external/icos/ico-back-consultoria": 259,
	"./tph/external/icos/ico-back-consultoria.svg": 259,
	"./tph/external/icos/ico-back-convenios": 260,
	"./tph/external/icos/ico-back-convenios.svg": 260,
	"./tph/external/icos/ico-back-db-latam": 261,
	"./tph/external/icos/ico-back-db-latam.svg": 261,
	"./tph/external/icos/ico-back-diario": 262,
	"./tph/external/icos/ico-back-diario.svg": 262,
	"./tph/external/icos/ico-back-dictado": 263,
	"./tph/external/icos/ico-back-dictado.svg": 263,
	"./tph/external/icos/ico-back-especialidades": 264,
	"./tph/external/icos/ico-back-especialidades.svg": 264,
	"./tph/external/icos/ico-back-gestor_despachos": 265,
	"./tph/external/icos/ico-back-gestor_despachos.svg": 265,
	"./tph/external/icos/ico-back-legislacion": 266,
	"./tph/external/icos/ico-back-legislacion.svg": 266,
	"./tph/external/icos/ico-back-solicitud": 267,
	"./tph/external/icos/ico-back-solicitud.svg": 267,
	"./tph/external/icos/ico-back-traducciones": 268,
	"./tph/external/icos/ico-back-traducciones.svg": 268,
	"./tph/external/icos/ico-base-de-datos": 269,
	"./tph/external/icos/ico-base-de-datos.svg": 269,
	"./tph/external/icos/ico-biblioteca-gps": 270,
	"./tph/external/icos/ico-biblioteca-gps.svg": 270,
	"./tph/external/icos/ico-biblioteca-t-conecta": 271,
	"./tph/external/icos/ico-biblioteca-t-conecta.svg": 271,
	"./tph/external/icos/ico-biblioteca-virtual": 272,
	"./tph/external/icos/ico-biblioteca-virtual.svg": 272,
	"./tph/external/icos/ico-btn-up": 273,
	"./tph/external/icos/ico-btn-up.svg": 273,
	"./tph/external/icos/ico-calculadoras": 274,
	"./tph/external/icos/ico-calculadoras.svg": 274,
	"./tph/external/icos/ico-computo": 275,
	"./tph/external/icos/ico-computo.svg": 275,
	"./tph/external/icos/ico-consultoria": 276,
	"./tph/external/icos/ico-consultoria.svg": 276,
	"./tph/external/icos/ico-convenios": 277,
	"./tph/external/icos/ico-convenios.svg": 277,
	"./tph/external/icos/ico-db-latam": 278,
	"./tph/external/icos/ico-db-latam.svg": 278,
	"./tph/external/icos/ico-diario": 279,
	"./tph/external/icos/ico-diario.svg": 279,
	"./tph/external/icos/ico-dictado": 280,
	"./tph/external/icos/ico-dictado.svg": 280,
	"./tph/external/icos/ico-especialidades": 281,
	"./tph/external/icos/ico-especialidades.svg": 281,
	"./tph/external/icos/ico-footer-facebook": 282,
	"./tph/external/icos/ico-footer-facebook.svg": 282,
	"./tph/external/icos/ico-footer-instragram": 283,
	"./tph/external/icos/ico-footer-instragram.svg": 283,
	"./tph/external/icos/ico-footer-linkedin": 284,
	"./tph/external/icos/ico-footer-linkedin.svg": 284,
	"./tph/external/icos/ico-footer-twitter": 285,
	"./tph/external/icos/ico-footer-twitter.svg": 285,
	"./tph/external/icos/ico-footer-youtube": 286,
	"./tph/external/icos/ico-footer-youtube.svg": 286,
	"./tph/external/icos/ico-gestor_despachos": 287,
	"./tph/external/icos/ico-gestor_despachos.svg": 287,
	"./tph/external/icos/ico-legislacion": 288,
	"./tph/external/icos/ico-legislacion.svg": 288,
	"./tph/external/icos/ico-llamada": 289,
	"./tph/external/icos/ico-llamada.svg": 289,
	"./tph/external/icos/ico-solicitud": 290,
	"./tph/external/icos/ico-solicitud.svg": 290,
	"./tph/external/icos/ico-traducciones": 291,
	"./tph/external/icos/ico-traducciones.svg": 291,
	"./tph/external/icos/ico-whatsapp": 292,
	"./tph/external/icos/ico-whatsapp.svg": 292,
	"./tph/external/img/bg-aro-content": 293,
	"./tph/external/img/bg-aro-content.svg": 293,
	"./tph/external/img/btn-call": 294,
	"./tph/external/img/btn-call.svg": 294,
	"./tph/external/img/btn-plus": 295,
	"./tph/external/img/btn-plus.svg": 295,
	"./tph/external/img/btn-whatsapp": 296,
	"./tph/external/img/btn-whatsapp.svg": 296,
	"./tph/external/img/header-compu-hero": 43,
	"./tph/external/img/header-compu-hero.png": 43,
	"./tph/external/img/header-compu-hero.svg": 517,
	"./tph/external/logos/logo-conversa": 297,
	"./tph/external/logos/logo-conversa.svg": 297,
	"./tph/external/logos/logo-footer": 298,
	"./tph/external/logos/logo-footer.svg": 298,
	"./tph/external/logos/logo-header": 299,
	"./tph/external/logos/logo-header.svg": 299,
	"./tph/external/logos/logo-sofia": 300,
	"./tph/external/logos/logo-sofia.svg": 300,
	"./tph/favicon.ico": 518,
	"./tph/icoImportant": 301,
	"./tph/icoImportant.svg": 301,
	"./tph/icoImportant.webp": 519,
	"./tph/ico_biblioteca": 302,
	"./tph/ico_biblioteca.svg": 302,
	"./tph/ico_consultoria": 303,
	"./tph/ico_consultoria.svg": 303,
	"./tto/bghead": 304,
	"./tto/bghead.png": 304,
	"./ury/bghead": 305,
	"./ury/bghead.png": 305,
	"./ven/bghead": 306,
	"./ven/bghead.png": 306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 507;